var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 536,
    viewBox: "0 0 512 536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M469.333 177.6a8.534 8.534 0 0 0 8.534-8.533c0-14.139 11.461-25.6 25.6-25.6a8.534 8.534 0 0 0 0-17.067c-14.139 0-25.6-11.461-25.6-25.6a8.534 8.534 0 0 0-17.067 0c0 14.139-11.461 25.6-25.6 25.6a8.534 8.534 0 0 0 0 17.067c14.139 0 25.6 11.461 25.6 25.6a8.534 8.534 0 0 0 8.533 8.533zm-18.666-43.535a90.89 90.89 0 0 0 18.798-18.798 90.834 90.834 0 0 0 18.797 18.798 90.945 90.945 0 0 0-18.797 18.797 90.89 90.89 0 0 0-18.798-18.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.067 373.867h17.066v17.066H17.067zM17.067 408h17.066v17.067H17.067zM0 390.933h17.067V408H0zM34.133 390.933H51.2V408H34.133zM187.904 254.4a8.534 8.534 0 0 0 0-17.067h-.085a8.534 8.534 0 0 0 .085 17.067zM324.437 203.2h-.085a8.577 8.577 0 1 0 .085 0zM358.57 408h-.085a8.577 8.577 0 1 0 .086 0zM94.037 314.133h-.085a8.577 8.577 0 1 0 .085 0zM213.504 322.667h-.085a8.577 8.577 0 1 0 .085 0zM170.837 134.933a8.534 8.534 0 0 0 0-17.066h-.085a8.534 8.534 0 0 0 .085 17.066zM247.467 501.867h17.066V536h-17.066zM0 271.467h34.133v17.066H0zM477.867 271.467H512v17.066h-34.133zM79.297 98.3L91.365 86.23l17.065 17.065-12.068 12.068zM403.566 103.26l17.064-17.064L432.7 98.265l-17.065 17.064zM62.233 444.635l17.064-17.065 12.068 12.068-17.064 17.065zM420.638 439.599l12.068-12.068 17.065 17.064-12.069 12.068z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M267 85c72.219 44.298 109.022 112.273 110.408 203.924 1.387 91.652-33.44 154.25-104.482 187.793"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M267.448 85C195.23 129.298 158.426 197.273 157.04 288.924c-1.387 91.652 33.44 154.25 104.482 187.793"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M77 214.568C141.619 187.523 204.04 174 264.263 174c60.224 0 122.645 13.523 187.264 40.568M77 348c64.619 27.045 127.04 40.568 187.263 40.568 60.224 0 122.645-13.523 187.264-40.568"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 280.5,
    r: 200.5,
    stroke: "#E9530D",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M59 281.5h411M267.5.888v483.818"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.847 252.296a7.482 7.482 0 0 0 0-14.963h-.075a7.482 7.482 0 0 0 .075 14.963zM323.356 203.2h-.075a7.5 7.5 0 1 0 .075 0zM357.49 408h-.075a7.5 7.5 0 1 0 .074 0zM92.956 314.133h-.075a7.5 7.5 0 1 0 .075 0zM212.423 322.667h-.075a7.5 7.5 0 1 0 .075 0zM169.78 132.83a7.482 7.482 0 0 0 0-14.963h-.075a7.482 7.482 0 0 0 .075 14.962z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomLine);
export default __webpack_public_path__ + "static/media/room-line.2773dc2980ac4dd69560c02502030327.svg";
export { ForwardRef as ReactComponent };